import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PillProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'warning' | 'error' | 'success' | 'primary' | 'secondary';
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const variantStyles = {
  warning: 'bg-yellow-200 text-yellow-700',
  error: 'bg-red-300 text-red-600',
  success: 'bg-green-300 text-green-600',
  primary: 'bg-sky-300 text-sky-600',
  secondary: 'bg-purple-300 text-purple-600',
};

const Pill = React.forwardRef<HTMLDivElement, PillProps>(
  ({ className, variant = 'primary', icon, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'inline-flex items-center gap-2 px-3 py-1 rounded-lg text-small',
          variantStyles[variant],
          className
        )}
        {...props}
      >
        {icon && <span>{icon}</span>}
        <span>{children}</span>
      </div>
    );
  }
);
Pill.displayName = 'Pill';

export { Pill };
